import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import './MonthlyCashbook.css';

const MonthlyCashbook = () => {
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [loanData, setLoanData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - 5 + i);

  const fetchMonthlyData = async () => {
    if (!selectedMonth) return;
    
    setLoading(true);
    setError('');
    
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/monthly-cashbook/${selectedMonth}/${selectedYear}`
      );
      
      setLoanData(response.data.loans);
      setTotalAmount(response.data.totalAmount);
    } catch (err) {
      setError('Failed to fetch monthly data');
      console.error('Error fetching monthly data:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedMonth) {
      fetchMonthlyData();
    }
  }, [selectedMonth, selectedYear]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB'); // DD/MM/YYYY format
  };

  const formatAmount = (amount) => {
    return parseFloat(amount).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="monthly-cashbook">
      <div className="cashbook-header">
        <h2>Monthly Cashbook</h2>
        
        <div className="controls">
          <div className="control-group">
            <label htmlFor="month-select">Choose Month:</label>
            <select 
              id="month-select"
              value={selectedMonth} 
              onChange={(e) => setSelectedMonth(e.target.value)}
              className="month-select"
            >
              <option value="">Select Month</option>
              {months.map(month => (
                <option key={month} value={month}>{month}</option>
              ))}
            </select>
          </div>
          
          <div className="control-group">
            <label htmlFor="year-select">Year:</label>
            <select 
              id="year-select"
              value={selectedYear} 
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              className="year-select"
            >
              {years.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          
          <button 
            onClick={handlePrint} 
            className="print-btn"
            disabled={!selectedMonth || loanData.length === 0}
          >
            Print Report
          </button>
        </div>
      </div>

      {loading && <div className="loading">Loading...</div>}
      
      {error && <div className="error">{error}</div>}

      {selectedMonth && loanData.length > 0 && (
        <div className="cashbook-report">
          <div className="report-header">
            <h3>Money Landing SI No:- 000</h3>
            <h4>SHREE SIDDHARAMESHWAR FINANCE AND LEASING</h4>
            <p>Kasgi,Osmanabad</p>
            <p>Date: {new Date().toLocaleDateString('en-GB')}</p>
            <p>Month: {selectedMonth} {selectedYear}</p>
          </div>

          <div className="report-table">
            <table className="cashbook-table">
              <thead>
                <tr>
                  <th>SI No</th>
                  <th>NAME OF THE PARTY</th>
                  <th>FROM No-6</th>
                  <th>ACCOUNT No</th>
                  <th>LOAN TYPE</th>
                  <th>DATE</th>
                  <th>AMOUNT</th>
                </tr>
              </thead>
              <tbody>
                {loanData.map((loan, index) => (
                  <tr key={loan.account_no}>
                    <td>{index + 1}</td>
                    <td>{loan.loanee_name}</td>
                    <td>{loan.form_no}</td>
                    <td>{loan.account_no}</td>
                    <td>General Loan</td>
                    <td>{formatDate(loan.date)}</td>
                    <td className="amount-cell">{formatAmount(loan.loan_amount)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="total-row">
                  <td colSpan="6" className="total-label">TOTAL</td>
                  <td className="total-amount">{formatAmount(totalAmount)}</td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="report-footer">
            <p className="end-statement">+++ END OF STATEMENT +++</p>
            <div className="signature-section">
              <p>For: SHREE SIDDHARAMESHWAR FINANCE AND LEASING</p>
              <div className="signature-line">
                <span>_________________</span>
                <span>Mg. Partner</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedMonth && loanData.length === 0 && !loading && (
        <div className="no-data">
          <p>No loan data found for {selectedMonth} {selectedYear}</p>
        </div>
      )}
    </div>
  );
};

export default MonthlyCashbook;
